import APIService from './APIService'

const api = APIService()

export const listPortfolios = () =>
  api.get('/portfolios')

export const getPortfolio = (id) =>
  api.get(`/portfolios/${id}`)

export const getPortfolioSafetyRoles = (id) =>
  api.get(`/portfolios/${id}/safety-roles`)

export const createPortfolio = (body) =>
  api.post('/portfolios', body)

export const updatePortfolio = (id, body) =>
  api.patch(`/portfolios/${id}`, body)

export const deletePortfolio = (id) =>
  api.delete(`/portfolios/${id}`)

export const addBuildingPassports = (portfolioId, bpIds) =>
  api.post(`/portfolios/${portfolioId}/building-passports`, { bpIds })

export const removeBuildingPassport = (portfolioId, bpId) =>
  api.delete(`/portfolios/${portfolioId}/building-passports/${bpId}`)

export const getPortfoliosForBp = (bpId) =>
  api.get(`/building-passport/${bpId}/portfolios`)

export const getAltitudeSummary = (params = {}) => {
  const qs = new URLSearchParams(params).toString()
  return api.get(`/portfolios/altitude-summary${qs ? `?${qs}` : ''}`)
}

// Overview
export const getOverview = (portfolioId) =>
  api.get(`/portfolios/${portfolioId}/overview`)

// Audit
export const triggerAudit = (portfolioId) =>
  api.post(`/portfolios/${portfolioId}/audit`)

export const listAudits = (portfolioId) =>
  api.get(`/portfolios/${portfolioId}/audits`)

export const getAudit = (portfolioId, auditId) =>
  api.get(`/portfolios/${portfolioId}/audit/${auditId}`)

export const exportAuditPdf = (portfolioId, auditId) =>
  api.get(`/portfolios/${portfolioId}/audits/${auditId}/export/pdf`, { responseType: 'blob' })

export const listPortfolioUsers = (id) =>
  api.get(`/portfolios/${id}/access/users`)

export const getPortfolioAccessTree = (id) =>
  api.get(`/portfolios/${id}/access/tree`)

export const assignPortfolioUser = (id, body) =>
  api.post(`/portfolios/${id}/access/users`, body)

export const updatePortfolioUser = (id, portfolioUserId, body) =>
  api.patch(`/portfolios/${id}/access/users/${portfolioUserId}`, body)

export const revokePortfolioUser = (id, portfolioUserId) =>
  api.delete(`/portfolios/${id}/access/users/${portfolioUserId}`)

export const removeUserFromPortfolio = (id, userId) =>
  api.post(`/portfolios/${id}/access/remove-user`, { userId })

export const listPortfolioInvitations = (id) =>
  api.get(`/portfolios/${id}/access/invitations`)

export const deletePortfolioInvitation = (id, invitationId) =>
  api.delete(`/portfolios/${id}/access/invitations/${invitationId}`)

export const listPortfolioRevokedUsers = (id) =>
  api.get(`/portfolios/${id}/access/revoked-users`)

export const listPortfolioDomainGrants = (id) =>
  api.get(`/portfolios/${id}/access/domain-grants`)

export const getPortfolioDomainGrantMembers = (id, grantId) =>
  api.get(`/portfolios/${id}/access/domain-grants/${grantId}/members`)

export const previewPortfolioDomainGrant = (id, { domain, relationType }) =>
  api.get(`/portfolios/${id}/access/domain-grants/preview`, { params: { domain, relation_type: relationType } })

export const addPortfolioDomainGrant = (id, body) =>
  api.post(`/portfolios/${id}/access/domain-grants`, body)

export const removePortfolioDomainGrant = (id, grantId) =>
  api.delete(`/portfolios/${id}/access/domain-grants/${grantId}`)

export const restrictPortfolioDomainUser = (id, userId) =>
  api.post(`/portfolios/${id}/access/domain-restrictions`, { user_id: userId })

export const liftPortfolioDomainRestriction = (id, userId) =>
  api.delete(`/portfolios/${id}/access/domain-restrictions/${userId}`)

// Guru Chat
export const startChat = (portfolioId, question) =>
  api.post(`/portfolios/${portfolioId}/guru`, { question })

export const getChatHistory = (portfolioId) =>
  api.get(`/portfolios/${portfolioId}/guru/history`)

export const getChatStatus = (portfolioId, messageId) =>
  api.get(`/portfolios/${portfolioId}/guru/status/${messageId}`)

export const getPortfolioActivity = ({ portfolioId, page = 1, limit = 25 }) =>
  api.get(`/portfolios/${portfolioId}/activity?page=${page}&limit=${limit}`)
